var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSearchPropertyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8815 24.0064C12.8815 30.1405 17.872 35.1315 24.0064 35.1315C30.1405 35.1315 35.1315 30.1405 35.1315 24.0064C35.1315 17.872 30.1405 12.8815 24.0064 12.8815C17.872 12.8815 12.8815 17.872 12.8815 24.0064ZM30.4472 24.0064C30.4472 27.5578 27.5578 30.4472 24.0066 30.4472C20.4552 30.4472 17.5658 27.5578 17.5658 24.0066C17.5658 20.4552 20.4552 17.5658 24.0064 17.5658C27.5578 17.5658 30.4472 20.4552 30.4472 24.0064ZM53.9713 56.8703L47.4353 49.5918C48.6822 47.8605 49.4183 45.7375 49.4183 43.4459C49.4183 37.6342 44.69 32.9064 38.8788 32.9064C33.0676 32.9064 28.3392 37.6342 28.3392 43.4459C28.3392 49.2572 33.0675 53.985 38.8788 53.985C40.7061 53.985 42.4264 53.5172 43.9266 52.6955L50.4863 60L53.9713 56.8703ZM33.0234 43.4459C33.0234 40.2173 35.6501 37.5906 38.8787 37.5906C42.1073 37.5906 44.7339 40.2172 44.7339 43.4459C44.7339 46.6745 42.1072 49.3011 38.8787 49.3011C35.6502 49.3011 33.0234 46.6746 33.0234 43.4459ZM29.3613 55.3185C27.1357 57.3894 25.5971 58.6386 25.4781 58.7347L24.0063 59.9236L22.5342 58.7347C22.3068 58.5507 16.896 54.1576 11.4083 47.8569C3.83836 39.1658 0 31.3646 0 24.6702V24.0064C0 10.7693 10.7693 0 24.0064 0C37.2436 0 48.013 10.7693 48.013 24.0064V24.6703C48.013 26.5691 47.7031 28.5575 47.0878 30.6304C45.7554 29.7734 44.2968 29.1308 42.7652 28.7261C43.1264 27.3541 43.3287 25.9956 43.3287 24.6702V24.0064C43.3287 13.3521 34.6605 4.68434 24.0064 4.68434C13.3521 4.68434 4.68434 13.3521 4.68434 24.0064V24.6703C4.68434 35.983 19.26 49.6774 24.0064 53.8362C24.7463 53.1874 25.4762 52.5274 26.196 51.8564C27.0675 53.1658 28.135 54.3334 29.3613 55.3185Z",
    fill: "url(#paint0_linear_15048_172301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15048_172301",
    x1: -1.85196,
    y1: 33.1579,
    x2: 56.3524,
    y2: 33.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSearchPropertyIcon);
export default __webpack_public_path__ + "static/media/MapSearch-Property-Icon.3ae0287d4669e8fa73639a39811c3240.svg";
export { ForwardRef as ReactComponent };